export const CHAT_BLK_BUNDLE_PATH = '/blk-chatblk.umd.js';
export const CHAT_BLK_STYLE_PATH = '/style.css';
export const CHAT_BLK_DEMO_SITE_PATH = '/apps/chatblk/blk-chatblk.umd.js';
export const CHAT_BLK_BUNDLE_ID = 'blk-chatblk';
export const CHAT_BLK_PARCEL_ID = 'chatblk';
export const CHAT_BLK_WRAPPER_CLASS = 'chat-blk__wrapper';
export const CHAT_BLK_TOGGLE_EVENT = 'chatblktoggle';
export const CHAT_BLK_USER_STATUS_EVENT = 'chatblk_userStatus';
export const CHAT_BLK_LOAD_PARCEL_EVENT = 'chatblk_loadParcel';
export const CHAT_BLK_TOKEN_STATUS_EVENT = 'chatblk_tokenStatus';
export const CHAT_BLK_RESIZE_EVENT = 'chatblkresize';
export const CHAT_BLK_TOGGLE_EVENT_CLOSE = 'close';
export const CHAT_BLK_TOGGLE_EVENT_OPEN = 'open';
export const USED_CHAT_BLK_LOGIN_ENTRYPOINT = 'usedChatblkLoginEntrypoint';
export const CHAT_BLK = 'ChatBLK';
export const CHAT_BLK_BETA = 'ChatBLK Beta';
